module.exports = __webpack_public_path__ + "static/img/6.1f120ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/eng/6.png
// module id = kzcv
// module chunks = 0